(function() {
  function initAnnouncementMarquee() {
    const marquee = document.querySelector('.js-announcement-marquee');
    if (!marquee) return;

    const container = marquee.querySelector('.js-marquee-container');
    if (!container) return;

    let isSettingUp = false;
    let resizeTimeout;

    function setupMarquee() {
      if (isSettingUp) return;
      isSettingUp = true;

      // Remove animate class temporarily to recalculate
      container.classList.remove('animate');
      const items = container.querySelectorAll('.announcement-marquee__item');
      if (items.length === 0) {
        isSettingUp = false;
        return;
      }

      const firstItem = items[0];
      const marqueeWidth = marquee.offsetWidth;
      
      if (marqueeWidth === 0) {
        isSettingUp = false;
        return;
      }
      
      // Remove all items except the first one
      const itemsArray = Array.from(items);
      for (let i = itemsArray.length - 1; i > 0; i--) {
        itemsArray[i].remove();
      }
      
      // Clone the first item to measure the actual distance
      const firstItemElement = container.querySelector('.announcement-marquee__item');
      const clone = firstItemElement.cloneNode(true);
      container.appendChild(clone);
      
      // Force a reflow to ensure layout is calculated
      void container.offsetWidth;
      
      // Use requestAnimationFrame to ensure layout is fully calculated
      requestAnimationFrame(() => {
        // Measure the actual distance from first item start to second item start
        const firstRect = firstItemElement.getBoundingClientRect();
        const secondRect = clone.getBoundingClientRect();
        const itemWidthWithGap = secondRect.left - firstRect.left;
        
        // Remove the test clone
        clone.remove();
        
        if (itemWidthWithGap === 0) {
          isSettingUp = false;
          return;
        }
        
        // Calculate how many items we need for seamless loop
        // We need enough items to cover at least 2x the viewport width
        const itemsNeeded = Math.ceil((marqueeWidth * 2) / itemWidthWithGap) + 2;
        
        // Clone items to fill the required amount
        let currentCount = 1;
        
        while (currentCount < itemsNeeded) {
          const newClone = firstItemElement.cloneNode(true);
          container.appendChild(newClone);
          currentCount++;
        }
        
        // Set animation to move by exactly one item width + gap for seamless loop
        const baseDuration = parseFloat(getComputedStyle(marquee).getPropertyValue('--duration')) || 30;
        marquee.style.setProperty('--item-width', `-${itemWidthWithGap}px`);
        marquee.style.setProperty('--animation-duration', `${baseDuration}s`);
        
        // Reset transform to start position before re-enabling animation
        container.style.transform = 'translateX(0)';
        
        // Use requestAnimationFrame to ensure transform is applied before animation starts
        requestAnimationFrame(() => {
          container.classList.add('animate');
          isSettingUp = false;
        });
      });
    }

    function handleResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupMarquee, 100);
    }

    // Initial setup
    setupMarquee();
    window.addEventListener('resize', handleResize);
    
    // Recalculate after images load
    const images = marquee.querySelectorAll('img');
    let imagesLoaded = 0;
    const totalImages = images.length;
    
    if (totalImages === 0) {
      // No images, just do a delayed setup
      setTimeout(setupMarquee, 100);
    } else {
      images.forEach(img => {
        if (img.complete) {
          imagesLoaded++;
          if (imagesLoaded === totalImages) {
            setTimeout(setupMarquee, 50);
          }
        } else {
          img.addEventListener('load', () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              setTimeout(setupMarquee, 50);
            }
          }, { once: true });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementMarquee);
  } else {
    initAnnouncementMarquee();
  }
})();

